<script type="text/jsx">
import CapacityConfigRowV2 from '@/components/capacity/v2/config-row';
import ConfigCycleV2FreeTrial from '@/components/service/config-billing-cycle/v2/free-trial';
import { isEventSaasOrEventSassCore } from '@/common/constants';

export default {
  name: 'ConfigRowV2FreeTrial',
  extends: CapacityConfigRowV2,
  components: { ConfigCycle: ConfigCycleV2FreeTrial },
  methods: {
    mx_renderAmount() {
      return (<p class='opc-cycle__plan__price'>
              <span class='opc-cycle__plan__price--amount'>
                {this.amountInfo.amount}
              </span>
              <span class='opc-cycle__plan__price--unit'>
                {this.$t('billing.trial.unit_suffix', [this.amountInfo.cycleLabel])}<priceVATTip />
              </span>
      </p>);
    },
    mx_renderLicense() {
        // Current only support 1 license.
      return this.license > 1 ? <div class='opc-capacity-config-row__input__number'>
        <input-number-with-popover
          value={this.license}
          onChange={this.changeLicense}
          size='large'
          controls-position='both'
          min={this.minHosts}
          max={this.maxHosts}
          increaseTips={this.getIncreaseTips(this.selectCapacity, this.license)}
          decreaseTips={this.decreaseTips}
          unit={this.inputUnit}
          label={`${this.trackingPlanKey} + Select the number of ${this.planUnit}`}
        />
        {/* <span
          class="opc-capacity-config-row__input__number--unit">{this.$t(`billing.planform.unit.${this.planUnit}`)}</span> */}
        {(this.$slots.licenseTips || !this.licenseTips) ?
          this.$slots.licenseTips :
          <zm-tooltip
            class='opc-capacity-config-row__tooltips'
            role='button'
            aria-label='Learn more about Select the number of licenses'
            content={this.licenseTips}
            placement='bottom'
            onInput={this.toggleLicenseTips}>
            <i class='zm-icon-info-outline' />
          </zm-tooltip>}
      </div>: null;
    },
    mx_renderCycleRow() {
      const groupOptions = this.billingCycleGroupOptions.filter(group => group?.options?.length);
      const textViewModel = isEventSaasOrEventSassCore(this.planType, false) && groupOptions.length <= 1;
      return <config-cycle
        billingCycle={this.billingCycle}
        billingCycleList={this.billingCycleList}
        billingCycleGroupOptions={groupOptions}
        onSwitchCycleAction={this.switchBillingCycle}
        onSyncCycle={this.changeBillingCycle}
        plan-name={this.planName}
        textViewModel={textViewModel}
      />;
    },
  }
};
</script>
